export const ROW_TYPES = {
  HEADER: 'HEADER',
  DATA: 'DATA',
  DETAILS: 'DETAILS',
} as const;
